import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-logo/jb-logo.css.ts
var jb_logo_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}jb-anchor::part(anchor){color:rgb(var(--logo-color, var(--theme-color-white, 255 255 255)));display:block}svg{fill:var(--logo-color, var(--theme-color-white, 255 255 255));transition:var(--svg-transition)}path{transition:fill .1s ease;transition-delay:0s}@media(forced-colors: active){svg,svg path{fill:CanvasText}jb-anchor::part(anchor){color:CanvasText}}`;

export {
  jb_logo_css_default
};
